import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/entertainment', label: '分类' },
  { path: '/article/1', label: '资讯' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-circle-fill text-background-50 text-xl"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-900 whitespace-nowrap">
              紅桃視頻
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#download"
              className="whitespace-nowrap px-4 py-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200"
            >
              下载App
            </a>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-900`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-2 text-sm font-medium ${
                  location.pathname === link.path
                    ? 'text-primary-500'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#download"
              className="block w-full text-center px-4 py-2.5 text-sm font-medium rounded-full bg-primary-500 text-background-50"
            >
              下载App
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}